import { render, staticRenderFns } from "./TransferProductDetails.vue?vue&type=template&id=13f08c06&"
import script from "./TransferProductDetails.vue?vue&type=script&lang=js&"
export * from "./TransferProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports